export interface ScopeParts {
  verb: string;
  resource: string;
  id: string;
  sub?: string;
}

export function parseScope(scope: string): ScopeParts | null {
  const parts = scope.split(':');
  if (parts.length < 3 || parts.length > 4) return null;
  const [verb, resource, id, sub] = parts;
  if (verb.length === 0 || resource.length === 0 || id.length === 0) return null;
  // Normalize an empty trailing segment so humanizeScope doesn't render "#42: ".
  return { verb, resource, id, sub: sub === '' ? undefined : sub };
}

export function humanizeScope(scope: string): string | null {
  const parts = parseScope(scope);
  if (parts == null) return null;
  const tail = parts.sub != null && parts.sub !== '*' ? `: ${parts.sub}` : '';
  return `${capitalize(parts.verb)} ${parts.resource} #${parts.id}${tail}`;
}

function capitalize(s: string): string {
  return s.length === 0 ? s : s[0].toUpperCase() + s.slice(1);
}
